import VueElementLoading from 'vue-element-loading';
export default {
  name: 'loader',
  components: {
    VueElementLoading
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {
     //isLoading:false
    }
  },
  computed: {
  },
  mounted() {

  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/views/components/shared/loader/loader.component.js